function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6C0 2.67857 2.67857 0 5.99999 0C9.32143 0 12 2.67857 12 6C12 9.32143 9.32143 12 5.99999 12C2.67857 12 0 9.32143 0 6Z",
  fill: "#009999"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.53456H9.76345C9.56989 6.53456 9.35485 6.35944 9.31182 6.18432L8.27958 1.93779C8.21505 1.65323 8.08602 1.5 7.89248 1.5C7.69892 1.5 7.56988 1.65323 7.50538 1.95968L5.87097 9.86174L4.60216 4.58641C4.53763 4.30185 4.4086 4.14862 4.21506 4.14862C4.0215 4.14862 3.89247 4.30185 3.82796 4.58641L3.2258 7.30069V7.32258C3.2258 7.32258 3.2258 7.32258 3.2043 7.30069L3.03226 7.08181C2.79569 6.77536 2.30108 6.53456 1.89247 6.53456H0C0.0215054 6.70968 0.0430108 6.90669 0.0645162 7.08181H1.91398C2.15054 7.08181 2.49462 7.2569 2.62366 7.43202L2.79569 7.65093C2.94623 7.84794 3.16129 7.93548 3.35483 7.8917C3.54839 7.84794 3.69893 7.67282 3.74193 7.43202L4.23656 5.2431L5.52687 10.5622C5.5914 10.8468 5.72044 11 5.91397 11C6.10754 11 6.23657 10.8468 6.30107 10.5403L7.93548 2.63825L8.79572 6.31568C8.90322 6.75346 9.31182 7.08181 9.76345 7.08181H11.9355C11.957 6.90669 11.9785 6.70968 12 6.53456Z",
  fill: "white"
});

function SvgRateMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateMd);
export default __webpack_public_path__ + "static/media/rateMD.db42be86.svg";
export { ForwardRef as ReactComponent };